var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"v-tag",style:(_vm.style)},_vm.$listeners),[_c('span',[_vm._t("default")],2),(_vm.canRemove)?_c('button',[_c('font-awesome-icon',{staticClass:"mr-0",staticStyle:{"cursor":"pointer"},attrs:{"icon":"times"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }